define(
    'viewmodels/secured/help/guided/gettingStarted',[
        "viewmodels/ViewModel",
        "plugins/router",
        "helper/textParser",
        "services/session",
        "i19n!i19n/strings",
    ],
    function (ViewModel, router, textParser, session, i19n) {

        var vm = new ViewModel({
            i19n: i19n,
            id: '1',
            descriptions: ko.observableArray([]),
            todos: ko.observableArray([]),
            tip: ko.observable('')
        });

        vm.activate = function () {
            //text | href | target
            
            if (vm.descriptions().length == 0) {
                vm.descriptions.push("If you haven't already done so as part of the 30-day free trial, get the low-down on how fileplan works and explore the sample content in your instance. ");
                vm.descriptions.push("The fileplan client for Windows provides integration with Outlook, Word and Excel. Download and install the client to use fileplan seamlessly with the applications you use every day. ");
            }
            if (vm.todos().length == 0) {
                //session.settingsGuided().Topic1a
                vm.todos.push({ icon: 'fa-video-camera', isDone: false, html: textParser.toHtml('Watch the {Getting Started | http://www.fileplan.com/welcome-to-fileplan-video-introduction | _blank} video.') });
                vm.todos.push({ icon: 'fa-book', isDone: false, html: textParser.toHtml('Read the {fileplan for new users | http://help.fileplan.com/hc/en-us/articles/203110544-fileplan-for-new-users | _blank} article.') });
                vm.todos.push({ icon: 'fa-book', isDone: false, html: textParser.toHtml('Read the {How to download the fileplan Windows Client | http://help.fileplan.com/hc/en-us/articles/204063334-How-do-I-download-the-fileplan-Windows-Client- | _blank} article.') });
                vm.todos.push({ icon: 'fa-hand-pointer-o', isDone: false, html: textParser.toHtml('{Download | https://s3-ap-southeast-2.amazonaws.com/fileplan-download-public/fileplanWindowsClient.msi | _blank} the fileplan Windows client.') });
            }

            vm.tip(textParser.toHtml("Some time spent now in planning how you want to organise your documents in fileplan will be well rewarded down the track. "));
        };
        vm.attached = function () {
            $(".a-route").unbind("click");
            $(".a-route").bind("click", function (e) {
                router.navigate($(this).attr("href"));

                return false;
            });
        };

        return vm;
    }
);
